import { render, staticRenderFns } from "./c-calendar-v2.vue?vue&type=template&id=0c1768f4&scoped=true"
import script from "./c-calendar-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./c-calendar-v2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-calendar-v2.vue?vue&type=style&index=0&id=0c1768f4&prod&lang=less"
import style1 from "./c-calendar-v2.vue?vue&type=style&index=1&id=0c1768f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1768f4",
  null
  
)

export default component.exports